import { config } from '@percent/partner-dashboard/config'
import { env } from '@percent/partner-dashboard/env'
import { baseUrl } from '@percent/partner-dashboard/services/apiPaths'
import { mockInsightsChatFetch } from './mockInsightsChatFetch'

// Absolute URL: the transport uses fetch (SSE), not the axios baseURL.
export const INSIGHTS_CHAT_BASE_PATH = `${config.urls.api}${baseUrl}insights/chat`

// Mock the answer where there's no backend (localhost / tests); hit the real agent
// on deployed builds.
const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'
const USE_MOCK_ANSWER = env.NX_PUBLIC_REACT_APP_ENV === 'test' || isLocalhost

if (USE_MOCK_ANSWER && env.NX_PUBLIC_REACT_APP_ENV !== 'test') {
  // eslint-disable-next-line no-console
  console.warn('[insights-ai] serving a canned answer — the real /v1/insights/chat agent is NOT being called.')
}

// Passed to useAiChat: mock on localhost/tests; undefined on deployed builds (the
// transport falls back to the credentialed global fetch, matching cookie auth).
export const insightsChatFetch = USE_MOCK_ANSWER ? mockInsightsChatFetch : undefined
